import { render, staticRenderFns } from "./FeatureAlertCard.vue?vue&type=template&id=54a34758&scoped=true&"
import script from "./FeatureAlertCard.vue?vue&type=script&lang=js&"
export * from "./FeatureAlertCard.vue?vue&type=script&lang=js&"
import style0 from "./FeatureAlertCard.vue?vue&type=style&index=0&id=54a34758&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a34758",
  null
  
)

/* custom blocks */
import block0 from "./FeatureAlertCard.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./FeatureAlertCard.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=ru"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VList,VListItem,VRow})
